import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useGetAllRolesQuery } from "../../Store/Services/RoleService";
import RolesDialog from "../../Components/Role/RolesDialog";
import { openAddRoleModal } from "../../Store/Slices/brSlice";
import { useEffect } from "react";
import SearchBar from "../../Components/Shared/SearchBar";
import RolesTable from "../../Components/Role/RolesTable";
import styles from "./Management.module.css";

const RoleManagement = () => {
  const dispatch = useDispatch();
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  const [searchData, setSearchData] = useState([]);

  const { data: rolesData, isSuccess, isLoading } = useGetAllRolesQuery();

  return (
    <>
      {roles?.split(",").includes("PRIV_ECOM_BRDISPLAY") && (
        <div className={styles.pageContainer}>
          <div>
            <Toolbar className={styles.subNavBar}>
              <Typography className={styles.topic}>Role Management</Typography>

              {roles?.split(",").includes("PRIV_ECOM_ADDBR") && (
                <Button
                  onClick={() => dispatch(openAddRoleModal())}
                  variant="contained"
                  color="primary"
                  className={styles.buttonItem}
                  aria-label="Add New Role"
                >
                  Add New
                </Button>
              )}
            </Toolbar>
          </div>

          <Container>
            {isSuccess && (
              <SearchBar
                data={rolesData?.list || []}
                setSearchData={setSearchData}
                text="Search Roles"
                search="brName"
              />
            )}
          </Container>

          <Container>
            <RolesTable data={searchData} />
          </Container>

          <RolesDialog />
        </div>
      )}
    </>
  );
};

export default RoleManagement;
